<div class="details-container">
  <div class="header">
    <button class="back-btn" routerLink="/admin/celebrities">
      <i class="fas fa-arrow-left"></i>
      Retour
    </button>
    <h2>Détails de la Célébrité</h2>
  </div>

  <ng-container *ngIf="loading">
    <div class="loading">Chargement...</div>
  </ng-container>

  <ng-container *ngIf="error">
    <div class="error">{{error}}</div>
  </ng-container>

  <ng-container *ngIf="celebrity && !loading">
    <div class="content-grid">
      <!-- Informations principales -->
      <div class="card profile-card">
        <div class="profile-header">
          <img [src]="celebrity.profile_picture || 'assets/user-default.png'" alt="Avatar">
          <div class="profile-info">
            <h3>{{celebrity.name}}</h3>
            <p class="email">{{celebrity.email}}</p>
            <span class="category">{{celebrity.category}}</span>
            <span class="status" [class]="celebrity.status">{{celebrity.status}}</span>
          </div>
        </div>
        <div class="profile-actions">
          <button class="status-btn" [class.activate]="celebrity.status === 'inactive'"
            [class.deactivate]="celebrity.status === 'active'"
            (click)="updateStatus(celebrity.status === 'active' ? 'inactive' : 'active')">
            <i class="fas" [class.fa-check-circle]="celebrity.status === 'inactive'"
              [class.fa-ban]="celebrity.status === 'active'"></i>
            {{celebrity.status === 'active' ? 'Désactiver' : 'Activer'}}
          </button>
          <button class="edit-btn" (click)="updateOfficialize(celebrity.official === '1' ? 0 : 1)">
              <i class="fas fa-check-circle"></i>
              {{celebrity.official === '1' ? 'Désofficialiser' : 'Officialiser'}}
          </button>
        </div>
        <div class="biography">
          <h4>Biographie</h4>
          <p>{{celebrity.biography}}</p>
        </div>
      </div>

      <!-- Statistiques -->
      <div class="card stats-card">
        <div class="card-header">
          <h4 class="mb-0">
            <i class="fas fa-chart-bar me-2"></i>
            Statistiques
          </h4>
        </div>
        <div class="card-body">
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-icon">
                <i class="fas fa-video"></i>
              </div>
              <div class="stat-content">
                <span class="label">Vidéos totales</span>
                <span class="value" *ngIf="!loading">{{videos.length}}</span>
                <div class="spinner-border spinner-border-sm text-primary" *ngIf="loading" role="status">
                  <span class="visually-hidden">Chargement...</span>
                </div>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <i class="fas fa-dollar-sign"></i>
              </div>
              <div class="stat-content">
                <span class="label">Revenus totaux</span>
                <span class="value" *ngIf="!loading">${{ revenues.usd }} / {{ revenues.cdf }} CDF</span>
                <div class="spinner-border spinner-border-sm text-primary" *ngIf="loading" role="status">
                  <span class="visually-hidden">Chargement...</span>
                </div>
              </div>
            </div>
            <!-- <div class="stat-item">
              <div class="stat-icon">
                <i class="fas fa-clock"></i>
              </div>
              <div class="stat-content">
                <span class="label">Temps de réponse moyen</span>
                <span class="value" *ngIf="!loading">6 h</span>
                <div class="spinner-border spinner-border-sm text-primary" *ngIf="loading" role="status">
                  <span class="visually-hidden">Chargement...</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Contrat -->
      <div class="card contract-card">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="mb-0">
            <i class="fas fa-file-contract me-2"></i>
            Contrat
          </h4>
          <div class="contract-actions">
            <button class="btn btn-primary btn-sm me-2" (click)="openContractModal()" *ngIf="!contract">
              <i class="fas fa-plus me-1"></i>
              Ajouter un contrat
            </button>
            <button class="btn btn-warning btn-sm" (click)="openContractModal(true)" *ngIf="contract">
              <i class="fas fa-edit me-1"></i>
              Modifier le contrat
            </button>
          </div>
        </div>

        <ng-container *ngIf="contract">
          <div class="contract-details">
            <div class="row">
              <div class="col-md-6">
                <div class="contract-info">
                  <div class="info-item">
                    <span class="label">Clé de répartition:</span>
                    <span class="value">{{ contract.cle_repartition }}%</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Date de création:</span>
                    <span class="value">{{ contract.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Dernière mise à jour:</span>
                    <span class="value">{{ contract.updated_at | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="contract-preview">
                  <div class="pdf-preview" (click)="openContractPdf()">
                    <i class="fas fa-file-pdf fa-3x"></i>
                    <p>Voir le contrat</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="no-contract" *ngIf="!contract">
          <div class="text-center py-4">
            <i class="fas fa-file-contract fa-3x text-muted mb-3"></i>
            <p class="text-muted">Aucun contrat n'a été ajouté pour cette célébrité</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Historique des tarifs personnalisés (overrides star) -->
    <div class="card tarif-history-card mt-3" *ngIf="celebrity && !loading">
      <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
        <h4 class="mb-0">
          <i class="fas fa-history me-2"></i>
          Historique des modifications des tarifs
        </h4>
        <div class="tarif-history-filter">
          <label class="small text-muted me-1">Type</label>
          <select
            class="form-select form-select-sm tarif-history-select"
            name="tarifHistoryTypeFilter"
            [(ngModel)]="tarifHistoryTypeFilter"
            (ngModelChange)="onTarifHistoryFilterChange()"
          >
            <option *ngFor="let opt of typeRequestFilterOptions" [value]="opt.key">{{ opt.label }}</option>
          </select>
        </div>
      </div>
      <p class="text-muted small mb-3">
        Journal des changements de tarifs personnalisés par type de demande (création, modification, suppression d’override).
      </p>

      <div *ngIf="tarifHistoryError" class="alert alert-danger py-2 small">{{ tarifHistoryError }}</div>

      <div *ngIf="tarifHistoryLoading && tarifHistoryItems.length === 0" class="text-center py-4 text-muted">
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        Chargement de l’historique…
      </div>

      <div *ngIf="!tarifHistoryLoading && tarifHistoryItems.length === 0 && !tarifHistoryError" class="text-center py-4 text-muted">
        Aucun changement enregistré pour cette célébrité.
      </div>

      <div class="table-responsive" *ngIf="tarifHistoryItems.length > 0">
        <table class="table table-sm table-hover align-middle tarif-history-table mb-0">
          <thead class="table-light">
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Action</th>
              <th>Ancien montant</th>
              <th>Nouveau montant</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tarifHistoryItems">
              <td class="text-nowrap text-muted small">{{ row.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ getTarifTypeLabel(row.type_request) }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="{
                    'bg-success': row.action === 'created',
                    'bg-warning text-dark': row.action === 'updated',
                    'bg-danger': row.action === 'deleted'
                  }"
                >
                  {{ getTarifActionLabel(row.action) }}
                </span>
              </td>
              <td class="font-monospace small">{{ formatTarifAmount(row.amount_old, row.currency_old) }}</td>
              <td class="font-monospace small">{{ formatTarifAmount(row.amount_new, row.currency_new) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngIf="tarifHistoryPagination && tarifHistoryPagination.last_page > 1"
        class="d-flex flex-wrap justify-content-center align-items-center gap-3 mt-3 pt-3 border-top"
      >
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          [disabled]="tarifHistoryLoading || tarifHistoryPagination.current_page <= 1"
          (click)="goTarifHistoryPage(-1)"
        >
          Précédent
        </button>
        <span class="small text-muted">
          Page {{ tarifHistoryPagination.current_page }} / {{ tarifHistoryPagination.last_page }}
          ({{ tarifHistoryPagination.total }} entrée{{ tarifHistoryPagination.total > 1 ? 's' : '' }})
        </span>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          [disabled]="tarifHistoryLoading || tarifHistoryPagination.current_page >= tarifHistoryPagination.last_page"
          (click)="goTarifHistoryPage(1)"
        >
          Suivant
        </button>
      </div>
    </div>

    <!-- Videos de la célébrité -->
    <div class="card videos-card p-3 mt-3" *ngIf="videos.length > 0">
      <h4 class="p-3">Vidéos publiées</h4>
      <div class="videos-grid">
        <div class="video-item" *ngFor="let video of videos">
          <div class="video-thumbnail">
            <img [src]="video.thumbnail" alt="Thumbnail">
            <button class="play-btn" (click)="openVideoModal(video)">
              <i class="fas fa-play"></i> 
            </button>
          </div>
          <div class="video-info">
            <h5>{{video.title}}</h5>
            <p class="video-date">{{video.createdAt | date:'dd/MM/yyyy'}}</p>
            <p class="video-stats">
              <span><i class="fas fa-eye"></i> 45</span>
              <span><i class="fas fa-heart"></i> 45</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Video Modal -->
  <div class="video-modal" *ngIf="selectedVideo" (click)="closeVideoModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="close-btn" (click)="closeVideoModal()">
        <i class="fas fa-times"></i>
      </button>
      <video controls [src]="selectedVideo?.file_url" class="modal-video"></video>
      <h3>{{selectedVideo?.title}}</h3>
    </div>
  </div>

  <app-contract-modal
    *ngIf="contractModalRef"
    [starId]="celebrity.id"
    [userId]="celebrity.user_id"
    [isEdit]="!!contract"
    [contract]="contract"
    (contractUpdated)="loadContract()">
  </app-contract-modal>
</div>

<style>
  .videos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1.5rem;
    padding: 1rem;
  }

  .video-item {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
  }

  .video-item:hover {
    transform: translateY(-2px);
  }

  .video-thumbnail {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    /* 16:9 Aspect Ratio */
    overflow: hidden;
  }

  .video-thumbnail img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.7);
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s;
  }

  .video-thumbnail:hover .play-btn {
    opacity: 1;
  }

  .play-btn i {
    color: white;
    font-size: 1.5rem;
  }

  .video-info {
    padding: 1rem;
  }

  .video-info h5 {
    margin: 0 0 0.5rem;
    font-size: 1rem;
    color: #333;
  }

  .video-date {
    color: #666;
    font-size: 0.9rem;
    margin: 0.25rem 0;
  }

  .video-stats {
    display: flex;
    gap: 1rem;
    color: #666;
    font-size: 0.9rem;
    margin: 0.5rem 0 0;
  }

  .video-stats span {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  /* Modal Styles */
  .video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background: #fff;
    padding: 1rem;
    border-radius: 8px;
    position: relative;
    width: 90%;
    max-width: 800px;
  }

  .modal-video {
    width: 100%;
    border-radius: 4px;
  }

  .close-btn {
    position: absolute;
    top: -40px;
    right: -40px;
    background: none;
    border: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0.5rem;
  }

  .modal-content h3 {
    margin: 1rem 0 0;
    color: #333;
  }


  .contract-actions .btn {
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.9rem;
  }

  .contract-details {
    background-color: #f8f9fa;
    border-radius: 10px;
    padding: 1.5rem;
  }

  .contract-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid #dee2e6;
  }

  .info-item:last-child {
    border-bottom: none;
  }

  .info-item .label {
    font-weight: 500;
    color: #495057;
  }

  .info-item .value {
    color: #212529;
  }

  .contract-preview {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .pdf-preview {
    background-color: #fff;
    border: 2px dashed #dee2e6;
    border-radius: 10px;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .pdf-preview:hover {
    border-color: #0389C9;
    background-color: #f8f9fa;
  }

  .pdf-preview i {
    color: #dc3545;
    margin-bottom: 1rem;
  }

  .pdf-preview p {
    margin: 0;
    color: #6c757d;
  }

  .no-contract {
    text-align: center;
    padding: 2rem;
    background-color: #f8f9fa;
    border-radius: 10px;
  }

  .no-contract i {
    color: #6c757d;
  }

  /* Stats Card Styles */
  .stats-card {
    background: linear-gradient(145deg, #ffffff, #f8f9fa);
    border: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
  }

  .stats-card:hover {
    transform: translateY(-5px);
  }

  .stats-card .card-header {
    background: transparent;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    padding: 1.25rem;
  }

  .stats-card .card-header h4 {
    color: #2c3e50;
    font-weight: 600;
    font-size: 1.25rem;
  }

  .stats-card .card-body {
    padding: 1.5rem;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
  }

  .stat-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    transition: all 0.3s ease;
  }

  .stat-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border-radius: 12px;
    color: #0389C9;
    font-size: 1.5rem;
  }

  .stat-content {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .stat-content .label {
    color: #6c757d;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .stat-content .value {
    color: #2c3e50;
    font-size: 1.25rem;
    font-weight: 600;
  }

  .spinner-border {
    width: 1.25rem;
    height: 1.25rem;
    border-width: 0.15em;
  }
</style>